// import python from './svg/skills/python.svg';
// import r from '/public/svg/skills/r.svg'; // Update with the correct path and filename
// import cpp from '/public/svg/skills/cpp.svg'; // Update with the correct path and filename
// import csharp from '/public/svg/skills/csharp.svg'; // Update with the correct path and filename
// import java from '/public/svg/skills/java.svg'; // Update with the correct path and filename
// import javascript from '/public/svg/skills/javascript.svg'; // Update with the correct path and filename
// import sql from '/public/svg/skills/sql.svg'; // Update with the correct path and filename
// import bash from '/public/svg/skills/bash.svg'; // Update with the correct path and filename

export const programmingLanguages = [
    'Python',
    'R',
    'C++',
    'C#',
    'Java',
    'JavaScript',
    'SQL',
    'Bash',
];

export const programmingLanguageImages = [
    './svg/skills/python.svg',
    './svg/skills/R.svg',
    './svg/skills/cplusplus.svg',
    './svg/skills/csharp.svg',
    './svg/skills/java.svg',
    './svg/skills/javascript.svg',
    './svg/skills/SQL.png',
    './svg/skills/bash.png'
];


export const frameworksAndLibraries = [
    'NumPy',
    'Pandas',
    'matplotlib',
    'Seaborn',
    'plotly',
    'OpenCV',
    'scikit-learn',
    'SKImage',
    'PyTorch',
    'TensorFlow',
    'Keras',
    'ONNX',
    'OpenVINO'
];
export const frameworksAndLibrariesImages = [
    './svg/skills/numpy.svg',
    './svg/skills/Pandas.png',
    './svg/skills/Matplotlib.png',
    './svg/skills/seaporn.png',
    './svg/skills/Ploty.png',
    './svg/skills/opencv.svg',
    './svg/skills/scikit-learn.png',
    './svg/skills/SKImage.png',
    './svg/skills/pytorch.svg',
    './svg/skills/TensorFlow.png',
    './svg/skills/Keras.png',
    './svg/skills/onnx.svg',
    './svg/skills/OpenVINO.png'
];
export const tools = [
    'LangChain',
    'Git',
    'GitHub',
    'Microsoft SQL Server',
    'MySQL',
    'PostgreSQL',
    'Cassandra',
    'MongoDB',
    'Spark',
    'React',
    'AWS',
    'SageMaker',
    'GCP',
    'Azure',
    'Docker',
    'Figma',
    'Canva',
    'Linux',
    'Nginx',
    'Selenium',
];
export const toolImages = [
    './svg/skills/langchain.png',
    './svg/skills/git.svg',
    './svg/skills/GitHub.png',
    './svg/skills/MicrosoftSQLServer.png',
    './svg/skills/MySQL.png',
    './svg/skills/postgresql.svg',
    './svg/skills/Cassandra.png',
    './svg/skills/mongoDB.svg',
    './svg/skills/Spark.png',
    './svg/skills/react.svg',
    './svg/skills/aws.svg',
    './svg/skills/Sagemaker.jpg',
    './svg/skills/gcp.svg',
    './svg/skills/azure.svg',
    './svg/skills/docker.svg',
    './svg/skills/figma.svg',
    './svg/skills/canva.svg',
    './svg/skills/Linux.png',
    './svg/skills/NGINX.png',
    './svg/skills/selenium.svg',
];
